import React from 'react';

import CollapsibleMenu from 'ui/properties-panel/collapsible-menu';

import styles from './resolution-panel.scss';

export default class ResolutionPanel extends React.Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.maxResolution !== this.props.maxResolution;
  }

  render() {
    const { isSvg, maxResolution } = this.props;
    const displayMaxResolution = isSvg ? Infinity : maxResolution;

    return (
      <CollapsibleMenu title="Image Resolution">
        <div className={styles.resolutions}>
          <div className={styles.resolution}>1x:</div>
          <div className={styles.enabled} />
          <div className={styles.resolution}>2x:</div>
          <div className={displayMaxResolution >= 2 ? styles.enabled : styles.disabled} />
          <div className={styles.resolution}>3x:</div>
          <div className={displayMaxResolution >= 3 ? styles.enabled : styles.disabled} />
        </div>

        {displayMaxResolution < 3 ? (
          <div>
            <br />
            To enable {displayMaxResolution < 2 ? '2x and 3x' : '3x'} for visitors with
            higher-resolution displays,{' '}
            <a onClick={this.props.onUploadImage} className={styles.link}>
              upload a larger version of this image
            </a>{' '}
            or make the image smaller in the canvas.
          </div>
        ) : null}
      </CollapsibleMenu>
    );
  }
}

ResolutionPanel.propTypes = {
  isSvg: React.PropTypes.bool,
  maxResolution: React.PropTypes.number,
  onUploadImage: React.PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/ui/properties-panel/images/resolution-panel.jsx